exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UpdatingStatus_wrapper_2XwJ .UpdatingStatus_spinner_6ZAB {\n  position: static;\n  margin: 15px 0 0 15px;\n}\n\n.UpdatingStatus_spinnerText_1V1x {\n  margin-top: 10px;\n\n  display: inline-block;\n  vertical-align: top;\n}\n\n.UpdatingStatus_wrapper_2XwJ {\n  margin-top: 15px 0;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "UpdatingStatus_wrapper_2XwJ",
	"spinner": "UpdatingStatus_spinner_6ZAB",
	"spinnerText": "UpdatingStatus_spinnerText_1V1x"
};